module.exports = (length) => {
  const sentenceArray = [];

  while (sentenceArray.join(' ').length < length) {
    const wordLength = Math.round(Math.random() * 7) + 1;
    let word = '█';

    while (word.length < wordLength) {
      word += '█';
    }

    sentenceArray.push(word);
  }

  return sentenceArray.join(' ');
};



// WEBPACK FOOTER //
// ./src/_utilities/loremblocksum.js